import React from 'react';
import { Box } from '@mui/material';
import {
    FilterDatatable,
    FiltersOpts,
    FlexyFilterValue,
    SerializedFlexyFilterValue,
} from '../DatatableHeader';
import { FlexyFilter } from '../FlexyFilter/FlexyFilter';
import useFilter from '../FlexyFilter/useFilter';
import { FlexyFilterProvider } from '../FlexyFilter/FlexyFilterProvider';

export type FieldAndValueFilter = {
    label: string;
    field: string;
    value: string;
};

export type FlexyFiltersListProps = {
    filtersOpts?: FiltersOpts;
    showHiddenFilters?: boolean;
};

export const FlexyFiltersList: React.FunctionComponent<FlexyFiltersListProps> = function (props) {
    const { filtersOpts, showHiddenFilters = false } = props;
    const { serializeValue, unserializeValue } = useFilter();
    const activeFilters = filtersOpts?.activeFilters || {};
    const activeFilterLabels = filtersOpts?.activeFilterLabels || {};
    const allFiltersField = filtersOpts?.filters || [];
    const filtersField = showHiddenFilters
        ? allFiltersField
        : allFiltersField.filter((f) => !f.hidden);

    const handleChange = (filter: FilterDatatable, value: FlexyFilterValue) => {
        if ((value === null || value === '') && filtersOpts?.onFilterDelete) {
            filtersOpts?.onFilterDelete(filter.field);

            return;
        }

        if (filtersOpts?.onFilterChange) {
            filtersOpts.onFilterChange(filter.field, serializeValue(filter, value));
        }
    };

    const handleClear = (filter: FilterDatatable) => {
        filtersOpts?.onFilterDelete(filter.field);
    };

    const filters = filtersField.map((filter: FilterDatatable) => {
        const value =
            activeFilters[filter.field] !== undefined ? activeFilters[filter.field] : null;

        return (
            <FlexyFilterProvider key={filter.label}>
                <FlexyFilter
                    filter={filter}
                    value={unserializeValue(filter, value as SerializedFlexyFilterValue)}
                    filterLabel={activeFilterLabels[filter.field]}
                    onChange={handleChange}
                    onClear={handleClear}
                />
            </FlexyFilterProvider>
        );
    });

    return (
        <Box
            sx={{
                display: 'flex',
                gap: '10px 8px',
                alignItems: 'center',
                flexWrap: 'nowrap',
                marginBottom: '1em',
            }}
        >
            {filters}
        </Box>
    );
};
